import React from 'react';
import styled from 'styled-components';

const Div = styled.div`
  font-size: 24px;
  font-weight: 700;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NotFound = () => {
  return <Div>Not Found</Div>;
}

export default NotFound;